import { render, staticRenderFns } from "./delivered.vue?vue&type=template&id=3386c72c&"
import script from "./delivered.vue?vue&type=script&lang=js&"
export * from "./delivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports